import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  style: {
    "white-space": "pre-line"
  }
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useSnackbarStore } from '@/services/snackbarStore';
export default {
  __name: 'SnackbarComponent',
  setup(__props) {
    const snackbarStore = useSnackbarStore();
    return (_ctx, _cache) => {
      const _component_v_snackbar = _resolveComponent("v-snackbar");
      return _openBlock(), _createBlock(_component_v_snackbar, {
        modelValue: _unref(snackbarStore).isVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(snackbarStore).isVisible = $event),
        eager: "",
        timeout: -1,
        color: _unref(snackbarStore).color,
        "multi-line": _unref(snackbarStore).multiLine,
        elevation: "24",
        location: "bottom right",
        class: "print:invisible"
      }, {
        actions: _withCtx(() => [_createVNode(LlSecondaryButton, {
          color: "surface",
          variant: "text",
          icon: "mdi-close",
          "aria-label": "Close notification",
          "data-cy": `${_unref(snackbarStore).color}-message`,
          onClick: _unref(snackbarStore).closeSnackbar
        }, null, 8, ["data-cy", "onClick"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createTextVNode(_toDisplayString(_unref(snackbarStore).message) + " ", 1), _unref(snackbarStore).actionText ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 0,
          color: "surface",
          variant: "text",
          onClick: _unref(snackbarStore).executeAction,
          class: "pa-0 ma-0 text-decoration-underline",
          style: {
            "min-width": "auto",
            "height": "auto",
            "font-size": "inherit",
            "text-transform": "none",
            "vertical-align": "baseline"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(snackbarStore).actionText), 1)]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue", "color", "multi-line"]);
    };
  }
};